import React, { useRef, useState, useCallback } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

// ── High5 — Haziran 2026 Medya Planı (Canon/Hupalupa deck tarzı) ───────────
// Toplam ₺900.000 SABİT. Yeni kanallar (RTB House 60K + Yandex 25K) Google'ın
// "Other" kaleminden (₺87.750) karşılandı; kalan ₺2.750 Google Other'da residual.
const GRAND = 900000;
const google = 500000;
const meta = 315000;
const RTB = 60000;
const YANDEX = 25000;
const OTHER_BEFORE = 87750;

const googleSub = [
  { label: 'Search', value: 292500 },
  { label: 'PMax', value: 204750 },
  { label: 'Other', value: 2750 },
];
const metaSub = [
  { label: 'Conversion (Purchase)', value: 157500 },
  { label: 'Retargeting', value: 126000 },
  { label: 'Traffic', value: 31500 },
];

const channels = [
  { label: 'Google', value: google, sub: googleSub, logo: '/google_ads-512.webp', bar: '#2563eb' },
  { label: 'Meta', value: meta, sub: metaSub, logo: '/meta-logo.svg', bar: '#4f46e5' },
  { label: 'RTB House', value: RTB, isNew: true, logo: '/RTBhouseicon.png', bar: '#dc2626' },
  { label: 'Yandex', value: YANDEX, isNew: true, logo: '/yandex-logo.svg', bar: '#ea580c' },
];

const barColors = { Google: '#2563eb', Meta: '#4f46e5', 'RTB House': '#dc2626', Yandex: '#ea580c' };

const brands = [
  { label: 'On', pct: 50, value: 450000 },
  { label: 'Asics', pct: 15, value: 135000 },
  { label: 'Hoka', pct: 10, value: 90000 },
  { label: 'Brooks', pct: 5, value: 45000 },
  { label: 'Salomon', pct: 5, value: 45000 },
  { label: 'Diğerleri', pct: 15, value: 135000, note: 'Saucony · Fabletics · Unna · Skechers · Doxa · Saysky · New Balance' },
];

const fmtCur = (n) => '₺' + Number(n || 0).toLocaleString('tr-TR');
const fmtNum = (n) => Number(n || 0).toLocaleString('tr-TR');
const pctOf = (v, total) => (v / total) * 100;
const fmtPct = (n) => n.toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '%';

export default function High5Haziran2026() {
  const slide1Ref = useRef(null);
  const slide2Ref = useRef(null);
  const [exporting, setExporting] = useState(false);

  const handleExportPDF = useCallback(async () => {
    if (exporting) return;
    setExporting(true);
    try {
      const refs = [slide1Ref, slide2Ref];
      const margin = 10;
      const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();
      const usableW = pageW - margin * 2;
      const usableH = pageH - margin * 2;
      for (let i = 0; i < refs.length; i++) {
        const el = refs[i].current;
        if (!el) continue;
        if (i > 0) pdf.addPage();
        const canvas = await html2canvas(el, { scale: 2, useCORS: true, logging: false, backgroundColor: '#ffffff', windowWidth: 1280, allowTaint: true });
        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const scale = Math.min(usableW / canvas.width, usableH / canvas.height);
        const w = canvas.width * scale, h = canvas.height * scale;
        pdf.addImage(imgData, 'JPEG', margin + (usableW - w) / 2, margin, w, h);
      }
      pdf.save('High5_Haziran_2026_Medya_Plani.pdf');
    } catch (err) {
      console.error('PDF export failed:', err);
    } finally {
      setExporting(false);
    }
  }, [exporting]);

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      {/* Export */}
      <div className="flex justify-end">
        <button
          onClick={handleExportPDF}
          disabled={exporting}
          className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-400 text-white text-sm font-semibold rounded-xl shadow-sm transition-colors"
        >
          {exporting ? (
            <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
          )}
          {exporting ? 'PDF Oluşturuluyor...' : 'PDF Olarak İndir'}
        </button>
      </div>

      {/* ═══ SLIDE 1: Overview ═══ */}
      <div ref={slide1Ref} className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        {/* Header */}
        <div className="bg-white border-b px-5 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src="/high5logo.svg" alt="High5" className="h-12 w-auto object-contain" />
            <div className="h-8 w-px bg-gray-200" />
            <div>
              <p className="text-xs font-bold text-gray-800">Haziran 2026 Medya Planı</p>
              <p className="text-[9px] text-gray-400">Google · Meta · RTB House · Yandex</p>
            </div>
          </div>
          <img src="/heyGlowylogo.png" alt="Glowytics" className="h-9 w-auto object-contain" />
        </div>

        <div className="p-6 space-y-6">
          {/* Plan özeti */}
          <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
            <p className="text-sm font-bold text-gray-800">Plan Özeti</p>
            <p className="text-xs text-gray-600 mt-1 leading-relaxed">
              High5 Haziran 2026 toplam medya bütçesi <strong>{fmtCur(GRAND)}</strong>. Bu ay hayatımıza <strong>RTB House</strong> ve
              <strong> Yandex</strong> giriyor; bu iki kanal Google'ın "Other" bütçesinden ({fmtCur(OTHER_BEFORE)}) karşılandı, toplam sabit kaldı.
            </p>
          </div>

          {/* KPI tiles */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
            <Kpi label="Toplam Bütçe" value={fmtCur(GRAND)} sub="Haziran 2026" tone="gray" />
            <Kpi label="Google" value={fmtCur(google)} sub={fmtPct(pctOf(google, GRAND))} tone="blue" />
            <Kpi label="Meta" value={fmtCur(meta)} sub={fmtPct(pctOf(meta, GRAND))} tone="indigo" />
            <Kpi label="RTB House" value={fmtCur(RTB)} sub="Yeni kanal" tone="red" />
            <Kpi label="Yandex" value={fmtCur(YANDEX)} sub="Yeni kanal" tone="orange" />
          </div>

          {/* Kanal stacked bar */}
          <div>
            <div className="flex w-full h-4 rounded-full overflow-hidden">
              {channels.map((c) => (
                <div key={c.label} style={{ width: `${pctOf(c.value, GRAND)}%`, backgroundColor: barColors[c.label] }} title={`${c.label} ${fmtCur(c.value)}`} />
              ))}
            </div>
            <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2">
              {channels.map((c) => (
                <span key={c.label} className="inline-flex items-center gap-1.5 text-[11px] text-gray-500">
                  <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: barColors[c.label] }} />
                  {c.label} {fmtPct(pctOf(c.value, GRAND))}
                </span>
              ))}
            </div>
          </div>

          {/* Kanal dağılım tablosu (mecra logoları + harcama) */}
          <div className="rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kanal Dağılımı — Toplam {fmtCur(GRAND)} üzerinden</div>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">%</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Harcama</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dağılım</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {channels.map((c) => (
                  <React.Fragment key={c.label}>
                    <tr>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <img src={c.logo} alt={c.label} className="h-5 w-auto max-w-[70px] object-contain" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                          <span className="text-sm font-semibold text-gray-800">{c.label}</span>
                          {c.isNew && <span className="text-[9px] font-bold bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full">YENİ</span>}
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-right text-gray-600">{fmtPct(pctOf(c.value, GRAND))}</td>
                      <td className="px-4 py-3 text-sm text-right font-bold text-gray-900">{fmtCur(c.value)}</td>
                      <td className="px-4 py-3">
                        <div className="h-2 bg-gray-100 rounded-full overflow-hidden w-40">
                          <div className="h-full rounded-full" style={{ width: `${pctOf(c.value, GRAND)}%`, backgroundColor: c.bar }} />
                        </div>
                      </td>
                    </tr>
                    {(c.sub || []).map((r) => (
                      <tr key={c.label + r.label} className="bg-gray-50/40">
                        <td className="px-4 py-1.5 pl-12 text-xs text-gray-500">↳ {r.label}</td>
                        <td className="px-4 py-1.5 text-xs text-right text-gray-400">{fmtPct(pctOf(r.value, c.value))}</td>
                        <td className="px-4 py-1.5 text-xs text-right text-gray-600">{fmtCur(r.value)}</td>
                        <td className="px-4 py-1.5" />
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
                <tr className="bg-gray-50 font-bold">
                  <td className="px-4 py-3 text-sm text-gray-900">Toplam</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-700">100%</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-900">{fmtCur(GRAND)}</td>
                  <td className="px-4 py-3" />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ═══ SLIDE 2: Marka Dağılımı + Yeni Kanallar ═══ */}
      <div ref={slide2Ref} className="bg-white rounded-2xl shadow-sm border overflow-hidden p-6 space-y-6">
        {/* Marka dağılımı tablosu */}
        <div className="rounded-xl border overflow-hidden">
          <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Marka Dağılımı — Toplam {fmtCur(GRAND)} üzerinden (tüm kanallar)</div>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Marka</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">%</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dağılım</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {brands.map((b) => (
                <tr key={b.label}>
                  <td className="px-4 py-3 text-sm font-medium text-gray-800">
                    {b.label}
                    {b.note && <span className="block text-[10px] font-normal text-gray-400">{b.note}</span>}
                  </td>
                  <td className="px-4 py-3 text-sm text-right text-gray-600">{b.pct}%</td>
                  <td className="px-4 py-3 text-sm text-right font-semibold text-gray-900">{fmtCur(b.value)}</td>
                  <td className="px-4 py-3">
                    <div className="h-2 bg-gray-100 rounded-full overflow-hidden w-40">
                      <div className="h-full bg-indigo-500 rounded-full" style={{ width: `${b.pct}%` }} />
                    </div>
                  </td>
                </tr>
              ))}
              <tr className="bg-gray-50 font-bold">
                <td className="px-4 py-3 text-sm text-gray-900">Toplam</td>
                <td className="px-4 py-3 text-sm text-right text-gray-700">100%</td>
                <td className="px-4 py-3 text-sm text-right text-gray-900">{fmtCur(GRAND)}</td>
                <td className="px-4 py-3" />
              </tr>
            </tbody>
          </table>
        </div>

        {/* Yeni kanallar */}
        <div className="rounded-xl border overflow-hidden">
          <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex items-center gap-2">
            Yeni Kanallar
            <span className="text-[10px] font-bold bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">BU AY</span>
          </div>
          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center justify-between">
                <span style={{ backgroundColor: '#dc2626' }} className="text-white text-[10px] font-bold px-2 py-0.5 rounded">RTB House</span>
                <span className="text-lg font-extrabold text-red-800">{fmtCur(RTB)}</span>
              </div>
              <p className="text-xs text-gray-600 mt-2">Programatik retargeting / prospecting. Google'ın Other bütçesinden ayrıldı.</p>
            </div>
            <div className="rounded-xl border border-orange-100 bg-orange-50 p-4">
              <div className="flex items-center justify-between">
                <span style={{ backgroundColor: '#ea580c' }} className="text-white text-[10px] font-bold px-2 py-0.5 rounded">Yandex</span>
                <span className="text-lg font-extrabold text-orange-800">{fmtCur(YANDEX)}</span>
              </div>
              <p className="text-xs text-gray-600 mt-2">Search / Display (TR pazarı). Google'ın Other bütçesinden ayrıldı.</p>
            </div>
          </div>
          <p className="px-4 pb-4 text-[11px] text-gray-400">
            Google "Other" ({fmtCur(OTHER_BEFORE)}) → RTB House {fmtCur(RTB)} + Yandex {fmtCur(YANDEX)} = {fmtCur(RTB + YANDEX)}; kalan {fmtCur(2750)} Google Other'da. Toplam bütçe {fmtCur(GRAND)} sabit.
          </p>
        </div>
      </div>
    </div>
  );
}

function Kpi({ label, value, sub, tone }) {
  const tones = {
    gray: 'border-gray-200 bg-gray-50 text-gray-800',
    blue: 'border-blue-100 bg-blue-50 text-blue-800',
    indigo: 'border-indigo-100 bg-indigo-50 text-indigo-800',
    red: 'border-red-100 bg-red-50 text-red-800',
    orange: 'border-orange-100 bg-orange-50 text-orange-800',
  };
  const labelTones = {
    gray: 'text-gray-500', blue: 'text-blue-600', indigo: 'text-indigo-600', red: 'text-red-600', orange: 'text-orange-600',
  };
  return (
    <div className={`rounded-xl border p-4 ${tones[tone]}`}>
      <span className={`text-[10px] font-medium uppercase ${labelTones[tone]}`}>{label}</span>
      <p className="text-xl font-bold mt-1">{value}</p>
      <p className={`text-[10px] mt-0.5 ${labelTones[tone]}`}>{sub}</p>
    </div>
  );
}
